import * as React from 'react';
import {ChangeEvent} from 'react';

import {Button, Form, Select, Input} from 'antd';

import Firebase, {withFirebase} from '../../components/Firebase';
import {FileType, ICourseMaterial} from '../../model/CourseMaterial';
import {FormStates} from '../../components/FormModal/FormWrapper';
import YearSelect from 'src/components/FormSelects/YearSelect';
import SemesterSelect from 'src/components/FormSelects/SemesterSelect';

const Option = Select.Option;


interface IProps {
  courseSlug: string;
  form: any;
  firebase: Firebase;
  onFormStateChange: (formState: FormStates, formMessage: string) => {}
}


class MaterialForm extends React.Component<IProps, {}> {

  private file: File;

  constructor(props: IProps) {
    super(props);
  }

  handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      this.file = event.target.files[0];
    }
  };

  handleUpload = () => {
    this.props.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.props.onFormStateChange(FormStates.handling, '');

        const courseMaterial: ICourseMaterial = {
          fileType: values.fileType,
          fileName: this.file.name,
          createdAt: this.props.firebase.serverTimestamp(), // TODO: maybe we should delegate it to model?
        };
        values.year !== -1 ? courseMaterial.year = values.year : null;
        values.semester !== '' ? courseMaterial.semester = values.semester : null;

        this.props.firebase.createMaterial(courseMaterial, this.file, this.props.courseSlug)
          .then((docRef) => {
            this.props.onFormStateChange(FormStates.success, 'Thank you for sharing a material, you will get +15 to your karma');
          })
          .catch((e) => {
            this.props.onFormStateChange(FormStates.error, 'Ups, something bad happened, please try again')
          })
      }
    });

  };

  public render() {
    const { getFieldDecorator } = this.props.form;

    return(
        <Form>
          <Form.Item label='File type'>
            {
              getFieldDecorator('fileType', {
                rules: [
                  {
                    required: true, message: 'Please choose type of file',
                  }
                ]
              })(
                <Select
                  showSearch={false}
                  placeholder="File type"
                  optionFilterProp="children"
                >
                  <Option value={FileType.syllabus}>Syllabus</Option>
                  <Option value={FileType.assignment}>Assignment</Option>
                  <Option value={FileType.quiz}>Quiz</Option>
                  <Option value={FileType.midterm}>Midterm</Option>
                  <Option value={FileType.final}>Final</Option>
                </Select>
              )
            }
          </Form.Item>

          <Form.Item
            label="Upload"
            extra="Allowed file types: pdf, doc, docx, jpg, jpeg, png"
          >
            {getFieldDecorator('file', {
              rules: [
                {
                  required: true, message: 'File is required!',
                }
              ]
            })(
              <Input type="file" required={true} onChange={this.handleFileChange}
                accept='.pdf,.doc,.docx, .jpg, .jpeg, .png'
              />
            )}
          </Form.Item>

          <YearSelect getFieldDecorator={getFieldDecorator} />

          <SemesterSelect getFieldDecorator={getFieldDecorator} />

          <Form.Item>
            <Button type="primary" onClick={this.handleUpload}>Upload</Button>
          </Form.Item>

        </Form>
    );
  }

}

export default Form.create<IProps>()(withFirebase(MaterialForm))